import React from 'react'
import useTranslation from 'next-translate/useTranslation'
import { Header } from '../../Header'
import { Gender } from '../Gender'
import { BirthDate } from '../BirthDate'

export const Container = () => {
  const { t } = useTranslation('common')

  return (
    <>
      <Header key='header'>{t('Dodatni podaci')}</Header>
      <Gender key='gender' />
      <BirthDate key='birthDate' />
    </>
  )
}

Container.displayName = 'AdditionalInfo'
